import React from "react";
import { useGetSelfUserQuery } from "./userApiV1";
import Loader from "@/components/loaders/Loader";

interface UserDataProviderProps {
  children?: React.ReactNode;
}

const UserDataProvider: React.FC<UserDataProviderProps> = ({ children }) => {
  const { isLoading } = useGetSelfUserQuery();

  if (isLoading) return <Loader />;

  return <>{children}</>;
};

export default UserDataProvider;
